(function () {

  'use strict';

  var POPUP_ID = 'dermawear-quick-view';

  /*
   * =========================================================
   * CACHE
   * =========================================================
   */

  var productCache = new Map();
  var loadingProducts = new Map();


  /*
   * =========================================================
   * CREATE POPUP
   * =========================================================
   */

  function createPopup() {

    var existing =
      document.getElementById(POPUP_ID);

    if (existing) {
      return existing;
    }

    var popup =
      document.createElement('div');

    popup.id = POPUP_ID;

    popup.innerHTML = `
      <div class="dvqv-overlay"></div>

      <div class="dvqv-modal">

        <button
          type="button"
          class="dvqv-close"
          aria-label="Close">
          &times;
        </button>

        <div class="dvqv-loader">
          <span></span>
          <span></span>
          <span></span>
        </div>

        <div class="dvqv-content"></div>

      </div>
    `;

    document.body.appendChild(popup);


    /*
     * Close button
     */

    var closeButton =
      popup.querySelector('.dvqv-close');

    if (closeButton) {

      closeButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          closePopup();

        }
      );

    }


    /*
     * Overlay
     */

    var overlay =
      popup.querySelector('.dvqv-overlay');

    if (overlay) {

      overlay.addEventListener(
        'click',
        function () {

          closePopup();

        }
      );

    }


    return popup;

  }


  /*
   * =========================================================
   * OPEN POPUP
   * =========================================================
   */

  function openPopup() {

    var popup =
      createPopup();

    popup.classList.add('active');

    document.documentElement.classList.add(
      'dvqv-open'
    );

    document.body.classList.add(
      'dvqv-open'
    );

  }


  /*
   * =========================================================
   * CLOSE POPUP
   * =========================================================
   */

  function closePopup() {

    var popup =
      document.getElementById(POPUP_ID);

    if (!popup) {
      return;
    }

    popup.classList.remove('active');

    popup.classList.remove(
      'dvqv-loading'
    );

    document.documentElement.classList.remove(
      'dvqv-open'
    );

    document.body.classList.remove(
      'dvqv-open'
    );

  }


  /*
   * =========================================================
   * LOADER
   * =========================================================
   */

  function showLoader() {

    var popup =
      createPopup();

    popup.classList.add(
      'dvqv-loading'
    );

  }


  function hideLoader() {

    var popup =
      document.getElementById(
        POPUP_ID
      );

    if (!popup) {
      return;
    }

    popup.classList.remove(
      'dvqv-loading'
    );

  }


  /*
   * =========================================================
   * PRODUCT URL
   * =========================================================
   */

  function getProductUrl(button) {

    if (!button) {
      return null;
    }

    var url =
      button.getAttribute('href');

    if (!url) {
      return null;
    }

    /*
     * Remove query string.
     */

    return url.split('?')[0];

  }


  /*
   * =========================================================
   * FETCH PRODUCT
   * =========================================================
   */

  function fetchProduct(productUrl) {

    /*
     * Cache
     */

    if (
      productCache.has(
        productUrl
      )
    ) {

      return Promise.resolve(
        productCache.get(productUrl)
      );

    }


    /*
     * Existing request
     */

    if (
      loadingProducts.has(
        productUrl
      )
    ) {

      return loadingProducts.get(
        productUrl
      );

    }


    var request =
      fetch(
        productUrl,
        {
          credentials:
            'same-origin',

          headers: {
            'X-Requested-With':
              'XMLHttpRequest'
          }
        }
      )

      .then(function (response) {

        if (!response.ok) {

          throw new Error(
            'Product request failed'
          );

        }

        return response.text();

      })

      .then(function (html) {

        var parser =
          new DOMParser();

        var page =
          parser.parseFromString(
            html,
            'text/html'
          );


        /*
         * Find Shopify product section.
         */

        var product =
          page.querySelector(
            'div[id$="main-product"]'
          );


        if (!product) {

          throw new Error(
            'Product container not found'
          );

        }


        var productHTML =
          product.outerHTML;


        productCache.set(
          productUrl,
          productHTML
        );


        loadingProducts.delete(
          productUrl
        );


        return productHTML;

      })

      .catch(function (error) {

        loadingProducts.delete(
          productUrl
        );

        throw error;

      });


    loadingProducts.set(
      productUrl,
      request
    );


    return request;

  }


  /*
   * =========================================================
   * PRELOAD PRODUCT
   * =========================================================
   */

  function preloadProduct(button) {

    var url =
      getProductUrl(button);

    if (!url) {
      return;
    }

    fetchProduct(url)
      .catch(function () {});

  }


  /*
   * =========================================================
   * NORMALIZE TEXT
   * =========================================================
   */

  function normalizeText(value) {

    if (!value) {
      return '';
    }

    return String(value)
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/\s+/g, ' ')
      .trim();

  }


  /*
   * =========================================================
   * PREPARE PRODUCT
   * =========================================================
   */

  function prepareProduct(
    product,
    productUrl
  ) {

    /*
     * Remove elements that should not appear
     * inside Quick View.
     */

    var removeSelectors = [

      'header.mobile-hide',

      '#section-info',

      '.pickup',

      '.product-recommendations',

      '.recommendations',

      '.has-social',

      '.syk-x',

      '.benefit',

      '.true-size',

      '.m6tb',

      /*
       * VERY IMPORTANT:
       *
       * Remove the ORIGINAL theme gallery.
       *
       * We use #all-product-images.
       */

      '.l4pr'

    ];


    removeSelectors.forEach(
      function (selector) {

        product
          .querySelectorAll(selector)
          .forEach(function (element) {

            element.remove();

          });

      }
    );


    /*
     * Main product container.
     */

    var mainProduct =
      product.querySelector(
        '.m6pr'
      );


    if (mainProduct) {

      mainProduct.classList.add(
        'dvqv-product'
      );

      mainProduct.classList.remove(
        'm6pr'
      );

    }


    /*
     * =====================================================
     * REAL CUSTOM GALLERY
     * =====================================================
     */

    var gallery =
      product.querySelector(
        '#all-product-images'
      );


    if (gallery) {

      gallery.classList.add(
        'dvqv-custom-gallery'
      );


      /*
       * Remove any theme gallery classes
       * that may affect the custom slider.
       */

      gallery
        .querySelectorAll(
          '.swiper-wrapper'
        )
        .forEach(function (element) {

          element.classList.remove(
            'swiper-wrapper'
          );

        });


      gallery
        .querySelectorAll(
          '.swiper-slide'
        )
        .forEach(function (element) {

          element.classList.remove(
            'swiper-slide'
          );

        });


      /*
       * Remove Slick classes if copied
       * from another initialization.
       */

      gallery
        .querySelectorAll(
          '.slick-initialized'
        )
        .forEach(function (element) {

          element.classList.remove(
            'slick-initialized'
          );

        });


      /*
       * Find image groups.
       */

      var groups =
        gallery.querySelectorAll(
          '.image-group-by-alt'
        );

      /*
       * Keep an untouched copy of every color group. The theme's
       * variant/gallery code can rewrite or empty hidden groups.
       * Quick View uses this snapshot to rebuild a group safely when
       * the customer switches back to a previous color.
       */
      groups.forEach(function (group) {
        if (!group._dvqvOriginalHTML) {
          group._dvqvOriginalHTML = group.innerHTML;
        }
      });


      /*
       * Hide all groups.
       */

      groups.forEach(
        function (group) {

          group.classList.add(
            'hide'
          );

        }
      );


      /*
       * IMPORTANT:
       *
       * Do NOT blindly use groups[0].
       *
       * The first group can sometimes have
       * no matching images.
       *
       * Find the first group containing
       * an actual image.
       */

      var firstValidGroup = null;


      for (
        var i = 0;
        i < groups.length;
        i++
      ) {

        if (
          groups[i].querySelector(
            '.main-slide img'
          )
        ) {

          firstValidGroup =
            groups[i];

          break;

        }

      }


      /*
       * Fallback.
       */

      if (!firstValidGroup) {

        for (
          var j = 0;
          j < groups.length;
          j++
        ) {

          if (
            groups[j].querySelector(
              'img'
            )
          ) {

            firstValidGroup =
              groups[j];

            break;

          }

        }

      }


      /*
       * Show valid first group.
       */

      if (firstValidGroup) {

        firstValidGroup.classList.remove(
          'hide'
        );

      }


      /*
       * Save gallery groups.
       */

      gallery._dvqvGroups =
        Array.from(groups);

    }


    /*
     * =====================================================
     * FIX PRODUCT LINKS
     * =====================================================
     */

    product
      .querySelectorAll('a')
      .forEach(function (link) {

        var href =
          link.getAttribute('href');


        if (
          href &&
          href.indexOf(
            '#section-info'
          ) !== -1
        ) {

          link.setAttribute(
            'href',
            productUrl
          );

        }

      });


    return product;

  }


  /*
   * =========================================================
   * CREATE NATIVE SLIDER
   * =========================================================
   *
   * No Slick dependency.
   *
   * First image is visible immediately.
   */

  function dvqvDeduplicateSlides(group) {
    if (!group) return;
    var main = group.querySelector('.main-image-slider');
    if (!main) return;

    var seen = {};
    main.querySelectorAll('.main-slide').forEach(function (slide) {
      var img = slide.querySelector('img');
      if (!img) return;
      var src = img.getAttribute('src') || img.getAttribute('data-src') || img.currentSrc || '';
      src = String(src).split('?')[0].trim();
      if (!src) return;
      if (seen[src]) {
        slide.remove();
      } else {
        seen[src] = true;
      }
    });
  }

  function dvqvImageKey(img) {
    if (!img) return '';
    return String(
      img.getAttribute('data-src') ||
      img.getAttribute('data-original') ||
      img.getAttribute('src') ||
      img.currentSrc ||
      ''
    ).split('?')[0].trim().toLowerCase();
  }

  function dvqvRemoveDuplicateMainSlides(group) {
    if (!group) return;

    var main = group.querySelector('.main-image-slider');
    if (!main) return;

    var seen = new Set();
    Array.from(main.querySelectorAll('.main-slide')).forEach(function (slide) {
      var img = slide.querySelector('img');
      var key = dvqvImageKey(img);

      /* Only dedupe when we have a real image URL. */
      if (!key) return;

      if (seen.has(key)) {
        slide.remove();
      } else {
        seen.add(key);
      }
    });
  }

  function createNativeSlider(
    group
  ) {

    if (!group) {
      return;
    }

    dvqvDeduplicateSlides(group);

    /*
     * Prevent duplicate initialization.
     */

    /* Remove duplicated default-color images before every slider refresh. */
    dvqvRemoveDuplicateMainSlides(group);

    if (
      group.dataset.dvqvSliderReady ===
      'true'
    ) {

      refreshSlider(
        group
      );

      return;

    }


    var main =
      group.querySelector(
        '.main-image-slider'
      );


    if (!main) {
      return;
    }


    var slides =
      Array.from(
        main.querySelectorAll(
          '.main-slide'
        )
      );


    /*
     * Keep only slides containing
     * real images.
     */

    slides =
      slides.filter(
        function (slide) {

          return !!slide.querySelector(
            'img'
          );

        }
      );


    if (!slides.length) {
      return;
    }


    /*
     * Main slider.
     */

    main.classList.add(
      'dvqv-native-slider'
    );


    main.style.display =
      'block';


    main.style.width =
      '100%';


    /*
     * Add slider viewport.
     */

    var viewport =
      main.querySelector(
        '.dvqv-slider-viewport'
      );


    if (!viewport) {

      viewport =
        document.createElement(
          'div'
        );

      viewport.className =
        'dvqv-slider-viewport';


      var track =
        document.createElement(
          'div'
        );

      track.className =
        'dvqv-slider-track';


      slides.forEach(
        function (slide) {

          track.appendChild(
            slide
          );

        }
      );


      viewport.appendChild(
        track
      );


      main.innerHTML = '';


      main.appendChild(
        viewport
      );

    }


    var track =
      viewport.querySelector(
        '.dvqv-slider-track'
      );


    /*
     * Force horizontal slides.
     */

    slides =
      Array.from(
        track.querySelectorAll(
          '.main-slide'
        )
      );


    slides.forEach(
      function (slide) {

        slide.classList.add(
          'dvqv-slide'
        );

      }
    );


    /*
     * Create arrows.
     */

    if (
      slides.length > 1
    ) {

      var oldPrev =
        main.querySelector(
          '.dvqv-gallery-arrow.dvqv-prev'
        );

      var oldNext =
        main.querySelector(
          '.dvqv-gallery-arrow.dvqv-next'
        );


      if (!oldPrev) {

        oldPrev =
          document.createElement(
            'button'
          );

        oldPrev.type =
          'button';

        oldPrev.className =
          'dvqv-gallery-arrow dvqv-prev';

        oldPrev.setAttribute(
          'aria-label',
          'Previous image'
        );

        oldPrev.innerHTML =
          '&#10094;';

        main.appendChild(
          oldPrev
        );

      }


      if (!oldNext) {

        oldNext =
          document.createElement(
            'button'
          );

        oldNext.type =
          'button';

        oldNext.className =
          'dvqv-gallery-arrow dvqv-next';

        oldNext.setAttribute(
          'aria-label',
          'Next image'
        );

        oldNext.innerHTML =
          '&#10095;';

        main.appendChild(
          oldNext
        );

      }


      /*
       * Previous.
       */

      oldPrev.onclick =
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          var current =
            parseInt(
              group.dataset.dvqvCurrent ||
              '0',
              10
            );

          showSlide(
            group,
            current - 1
          );

        };


      /*
       * Next.
       */

      oldNext.onclick =
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          var current =
            parseInt(
              group.dataset.dvqvCurrent ||
              '0',
              10
            );

          showSlide(
            group,
            current + 1
          );

        };

    }


    /*
     * =====================================================
     * THUMBNAILS
     * =====================================================
     */

    var thumbnail =
      group.querySelector(
        '.thumbnail-slider'
      );


    if (thumbnail) {

      thumbnail.classList.add(
        'dvqv-native-thumbnails'
      );


      var thumbSlides =
        Array.from(
          thumbnail.querySelectorAll(
            '.thumb-slide'
          )
        );


      /*
       * Remove empty thumbnails.
       */

      thumbSlides =
        thumbSlides.filter(
          function (slide) {

            return !!slide.querySelector(
              'img'
            );

          }
        );


      thumbSlides.forEach(
        function (
          thumb,
          index
        ) {

          thumb.classList.add(
            'dvqv-thumb'
          );


          thumb.dataset.index =
            index;


          thumb.onclick =
            function (event) {

              event.preventDefault();
              event.stopPropagation();

              showSlide(
                group,
                index
              );

            };

        }
      );

    }


    /*
     * Touch swipe.
     */

    var startX = 0;
    var startY = 0;


    viewport.addEventListener(
      'touchstart',
      function (event) {

        if (
          !event.touches ||
          !event.touches.length
        ) {
          return;
        }

        startX =
          event.touches[0].clientX;

        startY =
          event.touches[0].clientY;

      },
      {
        passive: true
      }
    );


    viewport.addEventListener(
      'touchend',
      function (event) {

        if (
          !event.changedTouches ||
          !event.changedTouches.length
        ) {
          return;
        }


        var endX =
          event.changedTouches[0].clientX;

        var endY =
          event.changedTouches[0].clientY;


        var distanceX =
          endX - startX;

        var distanceY =
          endY - startY;


        /*
         * Only horizontal swipe.
         */

        if (
          Math.abs(distanceX) >
          Math.abs(distanceY) &&
          Math.abs(distanceX) > 40
        ) {

          var current =
            parseInt(
              group.dataset.dvqvCurrent ||
              '0',
              10
            );


          if (
            distanceX < 0
          ) {

            showSlide(
              group,
              current + 1
            );

          } else {

            showSlide(
              group,
              current - 1
            );

          }

        }

      },
      {
        passive: true
      }
    );


    group.dataset.dvqvSliderReady =
      'true';


    group.dataset.dvqvCurrent =
      '0';


    /*
     * First image immediately.
     */

    showSlide(
      group,
      0
    );

  }


  /*
   * =========================================================
   * SHOW SLIDE
   * =========================================================
   */

  function showSlide(
    group,
    index
  ) {

    if (!group) {
      return;
    }


    var track =
      group.querySelector(
        '.dvqv-slider-track'
      );


    if (!track) {
      return;
    }


    var slides =
      Array.from(
        track.querySelectorAll(
          '.dvqv-slide'
        )
      );


    if (!slides.length) {
      return;
    }


    /*
     * Loop.
     */

    if (index < 0) {

      index =
        slides.length - 1;

    }


    if (
      index >= slides.length
    ) {

      index = 0;

    }


    group.dataset.dvqvCurrent =
      index;


    /*
     * Move horizontally.
     */

    track.style.transform =
      'translate3d(-' +
      (index * 100) +
      '%, 0, 0)';


    /*
     * Active slide.
     */

    slides.forEach(
      function (
        slide,
        slideIndex
      ) {

        slide.classList.toggle(
          'dvqv-active',
          slideIndex === index
        );

      }
    );


    /*
     * Active thumbnail.
     */

    var thumbs =
      group.querySelectorAll(
        '.dvqv-thumb'
      );


    thumbs.forEach(
      function (
        thumb,
        thumbIndex
      ) {

        thumb.classList.toggle(
          'dvqv-thumb-active',
          thumbIndex === index
        );

      }
    );

  }


  /*
   * =========================================================
   * REFRESH SLIDER
   * =========================================================
   */

  function refreshSlider(
    group
  ) {

    if (!group) {
      return;
    }


    var current =
      parseInt(
        group.dataset.dvqvCurrent ||
        '0',
        10
      );


    showSlide(
      group,
      current
    );

  }


  /*
   * =========================================================
   * INITIALIZE ALL GALLERY
   * =========================================================
   */

  function initializeGallery(
    popup
  ) {

    var gallery =
      popup.querySelector(
        '#all-product-images'
      );


    if (!gallery) {

      console.log(
        'Quick View: #all-product-images not found'
      );

      return;

    }


    var groups =
      gallery._dvqvGroups ||
      Array.from(
        gallery.querySelectorAll(
          '.image-group-by-alt'
        )
      );


    if (!groups.length) {

      console.log(
        'Quick View: no image groups'
      );

      return;

    }


    /*
     * Find first group with real image.
     */

    var firstGroup = null;


    groups.forEach(
      function (group) {

        group.classList.add(
          'hide'
        );


        if (
          !firstGroup &&
          group.querySelector(
            '.main-slide img'
          )
        ) {

          firstGroup =
            group;

        }

      }
    );


    if (!firstGroup) {

      firstGroup =
        groups.find(
          function (group) {

            return group.querySelector(
              'img'
            );

          }
        );

    }


    if (!firstGroup) {
      return;
    }


    /*
     * Show first group.
     * Always start from its untouched snapshot so the initial Quick View
     * cannot inherit a partially initialized PDP/Slick gallery.
     */
    if (firstGroup._dvqvOriginalHTML) {
      firstGroup.innerHTML = firstGroup._dvqvOriginalHTML;
      firstGroup.dataset.dvqvSliderReady = 'false';
      firstGroup.dataset.dvqvCurrent = '0';
    }

    firstGroup.classList.remove(
      'hide'
    );

    dvqvEnsureGroupReady(firstGroup);

    /*
     * Create slider immediately.
     */

    createNativeSlider(
      firstGroup
    );

    showSlide(firstGroup, 0);


    /*
     * Save current group.
     */

    gallery._dvqvCurrentGroup =
      firstGroup;

  }


  /*
   * =========================================================
   * RESTORE A COLOR GROUP IF THE THEME EMPTIED IT
   * =========================================================
   */

  function dvqvGroupHasImages(group) {
    if (!group) return false;

    var slides = group.querySelectorAll('.main-slide img');
    if (!slides.length) return false;

    return Array.from(slides).some(function (img) {
      return !!(
        img.getAttribute('src') ||
        img.getAttribute('data-src') ||
        img.getAttribute('data-original') ||
        img.getAttribute('data-lazy-src') ||
        img.getAttribute('data-lazy') ||
        img.getAttribute('srcset') ||
        img.getAttribute('data-srcset')
      );
    });
  }

  function dvqvRestoreGroupIfNeeded(group) {
    if (!group || dvqvGroupHasImages(group)) return false;

    var original = group._dvqvOriginalHTML;
    if (!original) return false;

    group.innerHTML = original;
    group.dataset.dvqvSliderReady = 'false';
    group.dataset.dvqvCurrent = '0';

    /* Reapply the small amount of normalization done in prepareProduct. */
    group.querySelectorAll('.swiper-wrapper').forEach(function (el) {
      el.classList.remove('swiper-wrapper');
    });
    group.querySelectorAll('.swiper-slide').forEach(function (el) {
      el.classList.remove('swiper-slide');
    });
    group.querySelectorAll('.slick-initialized').forEach(function (el) {
      el.classList.remove('slick-initialized');
    });

    return true;
  }

  function dvqvEnsureGroupReady(group) {
    if (!group) return false;

    dvqvRestoreGroupIfNeeded(group);

    /* Force lazy sources back into src before measuring the slider. */
    group.querySelectorAll('img').forEach(function (img) {
      var src =
        img.getAttribute('data-src') ||
        img.getAttribute('data-original') ||
        img.getAttribute('data-lazy-src') ||
        img.getAttribute('data-lazy');
      var srcset = img.getAttribute('data-srcset');

      if (src && (!img.getAttribute('src') || img.getAttribute('src').indexOf('data:') === 0)) {
        img.setAttribute('src', src);
      }
      if (srcset) img.setAttribute('srcset', srcset);
      img.loading = 'eager';
    });

    return dvqvGroupHasImages(group);
  }


  /*
   * =========================================================
   * FIND GROUP FOR VARIANT
   * =========================================================
   */

  function findGroupForValue(
    gallery,
    value
  ) {

    if (!gallery || !value) return null;

    var groups = gallery._dvqvGroups || Array.from(
      gallery.querySelectorAll('.image-group-by-alt')
    );

    var wanted = normalizeText(value);
    if (!wanted) return null;

    /* 1. Exact data-alt match always wins. */
    for (var i = 0; i < groups.length; i++) {
      var alt = normalizeText(groups[i].getAttribute('data-alt'));
      if (
        alt === wanted &&
        groups[i].querySelector('.main-slide img, img')
      ) {
        return groups[i];
      }
    }

    /* 2. Match a clean color token (White / Black / Skin etc.). */
    var wantedTokens = wanted.split(/[\/|,\-]+/)
      .map(normalizeText)
      .filter(Boolean);

    for (var p = 0; p < wantedTokens.length; p++) {
      var token = wantedTokens[p];

      for (var g = 0; g < groups.length; g++) {
        var groupAlt = normalizeText(groups[g].getAttribute('data-alt'));
        if (!groupAlt || !groups[g].querySelector('.main-slide img, img')) continue;

        var groupTokens = groupAlt.split(/[\/|,\-]+/)
          .map(normalizeText)
          .filter(Boolean);

        if (groupTokens.indexOf(token) !== -1) {
          return groups[g];
        }
      }
    }

    return null;
  }

  /*
   * =========================================================
   * SWITCH IMAGE GROUP
   * =========================================================
   */

  function switchGalleryGroup(
    popup,
    value
  ) {

    var gallery =
      popup.querySelector(
        '#all-product-images'
      );

    if (!gallery || !value) return;

    var group =
      findGroupForValue(
        gallery,
        value
      );

    /*
     * Critical: if the color group is not found, leave the
     * currently visible group untouched instead of blanking it.
     */
    if (!group) {
      console.warn(
        'Quick View: no image group for color:',
        value
      );
      return;
    }

    var groups =
      gallery._dvqvGroups ||
      Array.from(
        gallery.querySelectorAll(
          '.image-group-by-alt'
        )
      );

    /*
     * IMPORTANT:
     * Always rebuild the selected color from the untouched snapshot.
     *
     * The live PDP/theme gallery code can modify hidden color groups
     * (Slick/variant scripts may remove slides, add inline styles, or
     * leave the main slider in a hidden state). If we reuse that mutated
     * DOM, switching White -> Black -> White can produce thumbnails with
     * an empty/blank main slider.
     *
     * The snapshot is captured in prepareProduct() before Quick View
     * initializes anything, so it is the safest source for every switch.
     */
    if (group._dvqvOriginalHTML) {
      group.innerHTML = group._dvqvOriginalHTML;
      group.dataset.dvqvSliderReady = 'false';
      group.dataset.dvqvCurrent = '0';
    }

    if (!dvqvEnsureGroupReady(group)) {
      console.warn('Quick View: selected color group has no usable images:', value);
      return;
    }

    groups.forEach(function (item) {
      item.classList.add('hide');
    });

    /* Show only after the selected group's original HTML is restored. */
    group.classList.remove('hide');

    /*
     * Remove any duplicate main slides and force all lazy image sources
     * into src/srcset before the first frame is painted.
     */
    dvqvRemoveDuplicateMainSlides(group);

    group.querySelectorAll('img').forEach(function (img) {
      var src =
        img.getAttribute('data-src') ||
        img.getAttribute('data-original') ||
        img.getAttribute('data-lazy-src') ||
        img.getAttribute('data-lazy');

      var srcset = img.getAttribute('data-srcset');

      if (src) img.setAttribute('src', src);
      if (srcset) img.setAttribute('srcset', srcset);

      img.loading = 'eager';
      img.style.visibility = 'visible';
      img.style.opacity = '1';
    });

    /*
     * Build a fresh native slider for this color.
     * It always starts at slide 0, so returning to White is deterministic.
     */
    createNativeSlider(group);
    showSlide(group, 0);

    /*
     * Repaint after the group becomes visible. This is intentionally
     * repeated because the popup is inside a modal and its width can be
     * finalized one frame after the variant change.
     */
    requestAnimationFrame(function () {
      showSlide(group, 0);
      setTimeout(function () {
        showSlide(group, 0);
      }, 60);
    });

    gallery._dvqvCurrentGroup = group;
  }


  /*
   * =========================================================
   * VARIANT CONTROLS
   * =========================================================
   */


  /*
   * =========================================================
   * DERMAWEAR QUICK VIEW - ROBUST VARIANT ENGINE
   * =========================================================
   */

  function dvqvNorm(value) {
    return String(value || '')
      .replace(/&amp;/g, '&')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function dvqvProductJsonUrl(productUrl) {
    try {
      var u = new URL(productUrl, window.location.origin);
      var path = u.pathname.replace(/\/+$/, '');
      if (!/\.js$/i.test(path)) path += '.js';
      return path;
    } catch (e) {
      return String(productUrl).replace(/\/+$/, '') + '.js';
    }
  }

  function dvqvLoadVariantData(productUrl, popup) {
    if (!popup || popup._dvqvVariantDataPromise) {
      return popup && popup._dvqvVariantDataPromise;
    }

    var url = dvqvProductJsonUrl(productUrl);

    popup._dvqvVariantDataPromise = fetch(url, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Variant JSON request failed');
        return r.json();
      })
      .then(function (data) {
        popup._dvqvProductData = data;
        popup._dvqvVariants = Array.isArray(data.variants) ? data.variants : [];
        return popup._dvqvVariants;
      })
      .catch(function (err) {
        console.warn('Quick View variant JSON:', err);
        popup._dvqvVariants = [];
        return [];
      });

    return popup._dvqvVariantDataPromise;
  }

  function dvqvGetSelectedValues(popup) {
    var values = [];

    popup.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
      var name = String(input.name || '');
      if (/^(id|quantity)$/i.test(name)) return;

      var value = input.value || input.getAttribute('data-value') || input.getAttribute('title');
      if (!value) return;

      values.push({
        name: dvqvNorm(
          input.getAttribute('data-option-name') ||
          input.getAttribute('data-name') ||
          name
        ),
        value: dvqvNorm(value)
      });
    });

    popup.querySelectorAll('select').forEach(function (select) {
      var name = String(select.name || '');
      if (/^(id|quantity)$/i.test(name)) return;

      var value = select.value;
      if (!value) return;

      values.push({
        name: dvqvNorm(
          select.getAttribute('data-option-name') ||
          select.getAttribute('data-name') ||
          name.replace(/^options\[/i, '').replace(/\]$/, '')
        ),
        value: dvqvNorm(value)
      });
    });

    /* De-duplicate by value. This also handles themes using option1/option2 names. */
    var seen = {};
    return values.filter(function (item) {
      if (seen[item.value]) return false;
      seen[item.value] = true;
      return true;
    });
  }

  function dvqvGetSelectedOptionValues(popup) {
    return dvqvGetSelectedValues(popup).map(function (x) {
      return x.value;
    });
  }

  function dvqvFindVariant(popup) {
    var variants = popup._dvqvVariants || [];
    var selected = dvqvGetSelectedOptionValues(popup);

    if (!variants.length) return null;

    /* Exact match against Shopify variant.options. */
    var exact = variants.find(function (variant) {
      var opts = (variant.options || []).map(dvqvNorm);
      if (!opts.length || opts.length !== selected.length) return false;
      return opts.every(function (v) {
        return selected.indexOf(v) !== -1;
      });
    });

    if (exact) return exact;

    /* Flexible match: useful when the theme exposes only Color/Size radios. */
    var flexible = variants.find(function (variant) {
      var opts = (variant.options || []).map(dvqvNorm);
      return selected.length > 0 &&
        selected.every(function (v) { return opts.indexOf(v) !== -1; });
    });

    if (flexible) return flexible;

    /* Fallback to the theme's variant <select>. */
    var select = popup.querySelector('select[name="id"]');
    if (select && select.value) {
      var byId = variants.find(function (v) {
        return String(v.id) === String(select.value);
      });
      if (byId) return byId;
    }

    return null;
  }

  function dvqvFindVariantFromSelectText(popup) {
    var select = popup.querySelector('select[name="id"]');
    if (!select) return null;

    var selectedValues = dvqvGetSelectedOptionValues(popup);
    var options = Array.from(select.options || []);

    var option = options.find(function (opt) {
      if (!opt.value) return false;
      var text = dvqvNorm(opt.textContent || opt.getAttribute('data-title') || '');
      return selectedValues.length &&
        selectedValues.every(function (v) {
          return text.indexOf(v) !== -1;
        });
    });

    return option ? String(option.value) : null;
  }

  function dvqvSetVariantId(popup, variantId) {
    if (!popup || !variantId) return false;

    var id = String(variantId);

    popup.querySelectorAll('select[name="id"]').forEach(function (select) {
      select.value = id;
      Array.from(select.options || []).forEach(function (option) {
        option.selected = String(option.value) === id;
      });
      /* Do not dispatch change here: Shopify's variant listener can
         reset the selected Color and recreate the gallery. */
    });

    popup.querySelectorAll('input[name="id"]').forEach(function (input) {
      input.value = id;
    });

    popup.dataset.selectedVariantId = id;
    return true;
  }

  function dvqvSyncVariantId(popup) {
    if (!popup) return null;

    var variant = dvqvFindVariant(popup);
    var id = variant ? variant.id : dvqvFindVariantFromSelectText(popup);

    if (id) {
      dvqvSetVariantId(popup, id);
      popup._dvqvSelectedVariant = variant || { id: id };
      return String(id);
    }

    return null;
  }

function dvqvSetColorLabel(popup, color) {
  if (!popup || !color) return;

  var wanted = String(color).trim();
  if (!wanted) return;

  /*
   * Shopify/PDP already creates the correct structure:
   *
   * Color <span class="data-change-to-option-...">White</span>
   *
   * We ONLY change the text inside that span.
   * Nothing else is modified.
   */
  var colorValueElements = popup.querySelectorAll(
    '[class*="data-change-to-option-"]'
  );

  if (colorValueElements.length) {
    colorValueElements.forEach(function (el) {
      el.textContent = wanted;
    });

    return;
  }
}

  function dvqvRemoveExactSectionByText(popup, phrases) {
    if (!popup) return;

    var targets = [];
    var wanted = phrases.map(dvqvNorm);

    popup.querySelectorAll('details, section, li, .accordion, [class*="accordion"], [class*="product-info"], [class*="product-information"], [class*="offer"], [class*="offers"], [class*="promo"], [class*="coupon"]').forEach(function (el) {
      var text = dvqvNorm(el.textContent);
      if (!text) return;
      if (wanted.some(function (phrase) { return text === phrase || text.indexOf(phrase) === 0; })) {
        targets.push(el);
      }
    });

    targets.forEach(function (el) {
      if (el.parentElement) el.remove();
    });

    /* Exact heading/text fallback. */
    popup.querySelectorAll('h1,h2,h3,h4,h5,h6,strong,b,span,div,p,a,button').forEach(function (el) {
      var text = dvqvNorm(el.textContent);
      if (!wanted.some(function (phrase) { return text === phrase; })) return;

      var wrapper = el.closest('details, section, li, [class*="accordion"], [class*="offer"], [class*="offers"], [class*="promo"], [class*="coupon"]');
      if (wrapper && wrapper.parentElement) {
        wrapper.remove();
      } else if (el.parentElement && el.parentElement !== popup) {
        /* For a standalone Size Chart link, remove only its immediate wrapper. */
        if (wanted.indexOf('size chart') !== -1 && text === 'size chart') {
          el.parentElement.remove();
        }
      }
    });

    /* Special Offers card: identify it by its two offer texts, then remove the card. */
    var offerHeading = Array.from(popup.querySelectorAll('*')).find(function (el) {
      return dvqvNorm(el.textContent) === 'special offers';
    });

    if (offerHeading) {
      var node = offerHeading;
      for (var i = 0; i < 8 && node && node !== popup; i++, node = node.parentElement) {
        var cardText = dvqvNorm(node.textContent);
        if (cardText.indexOf('free women') !== -1 && cardText.indexOf('prepaid10') !== -1) {
          node.remove();
          break;
        }
      }
    }
  }

  function dvqvGetColorValue(popup) {
  if (!popup) return '';

  /* FIRST: read the color currently selected by customer */
  var input =
    popup.querySelector(
      'input[type="radio"][name*="Color" i]:checked'
    ) ||
    popup.querySelector(
      'input[type="radio"][data-option-name*="Color" i]:checked'
    ) ||
    popup.querySelector(
      'input[type="radio"][data-name*="Color" i]:checked'
    );

  if (input) {
    var value =
      input.getAttribute('data-value') ||
      input.value ||
      input.getAttribute('title') ||
      input.getAttribute('aria-label');

    if (value) {
      return String(value).trim();
    }
  }

  /* SECOND: selected option fallback */
  var selected = dvqvGetSelectedValues(popup);

  var color = selected.find(function (x) {
    return /color|colour/i.test(x.name);
  });

  if (color && color.value) {
    return String(color.value).trim();
  }

  /* THIRD: Shopify variant fallback */
  var variant = popup._dvqvSelectedVariant;
  var data = popup._dvqvProductData;

  if (variant && data && Array.isArray(data.options)) {
    var colorIndex = data.options.findIndex(function (name) {
      return /color|colour/i.test(String(name));
    });

    if (
      colorIndex >= 0 &&
      variant.options &&
      variant.options[colorIndex]
    ) {
      return String(
        variant.options[colorIndex]
      ).trim();
    }
  }

  return '';
}

  function dvqvSyncGallery(popup) {
    var color = dvqvGetColorValue(popup);
    if (!color) return;

    dvqvSetColorLabel(popup, color);

    var gallery = popup.querySelector('#all-product-images');
    if (!gallery) return;

    var group = findGroupForValue(gallery, color);
    if (!group) {
      console.warn('Quick View: gallery group not found:', color);
      return;
    }

    switchGalleryGroup(popup, color);
  }

  function dvqvRemoveQuickViewSections(popup) {
    if (!popup) return;

    dvqvRemoveExactSectionByText(popup, [
      'size chart',
      'manufactured & packed by',
      'country of origin',
      'for any feedback/ query',
      'for any feedback / query',
      'for any feedback/query',
      'secure & hassle-free payments',
      'secure and hassle-free payments'
    ]);

    /* Catch minor markup/text variations without touching unrelated content. */
    popup.querySelectorAll('h1,h2,h3,h4,h5,h6,strong,b,span,div,p,a,li').forEach(function (el) {
      var text = dvqvNorm(el.textContent);
      if (!text) return;

      if (
        text === 'for any feedback/ query' ||
        text === 'for any feedback / query' ||
        text === 'for any feedback/query' ||
        text === 'secure & hassle-free payments' ||
        text === 'secure and hassle-free payments'
      ) {
        var wrapper = el.closest('section, li, p, div, details');
        if (wrapper && wrapper !== popup) wrapper.remove();
      }
    });
  }

  function dvqvAddFullDetailsButton(popup, productUrl) {
    if (!popup || !productUrl) return;

    var old = popup.querySelectorAll('.dvqv-full-details');
    old.forEach(function (el) { el.remove(); });

    var button = document.createElement('a');
    button.className = 'dvqv-full-details';
    button.href = productUrl;
    button.textContent = 'VIEW FULL DETAILS';

    /*
     * Put VIEW FULL DETAILS AFTER the complete PDP purchase area:
     *
     * Add to Cart
     * Buy It Now / dynamic payment button
     * VIEW FULL DETAILS
     *
     * This is important because the previous version placed the link
     * inside .custom-wishlist-addtocart, which puts it before the
     * Buy It Now button when the theme renders the dynamic payment
     * button outside that wrapper.
     */
    var dynamicBuy = popup.querySelector(
      '.overlay-dynamic_buy_button, .shopify-payment-button'
    );

    if (dynamicBuy && dynamicBuy.parentNode) {
      dynamicBuy.parentNode.insertBefore(button, dynamicBuy.nextSibling);
      return;
    }

    var addToCartWrap = popup.querySelector('.custom-wishlist-addtocart');
    if (addToCartWrap && addToCartWrap.parentNode) {
      addToCartWrap.parentNode.insertBefore(button, addToCartWrap.nextSibling);
      return;
    }

    var submit = popup.querySelector(
      'button[name="add"], button[type="submit"], input[type="submit"]'
    );
    if (submit && submit.parentNode) {
      submit.parentNode.insertBefore(button, submit.nextSibling);
      return;
    }

    var form = popup.querySelector('form[action*="/cart/add"], form[action*="/cart"], form[action*="cart"]');
    if (form) {
      form.appendChild(button);
      return;
    }

    var product = popup.querySelector('.dvqv-product');
    if (product) product.appendChild(button);
  }

  function dvqvProtectCartSubmit(popup) {
    if (!popup || popup._dvqvCartProtected) return;
    popup._dvqvCartProtected = true;

    popup.addEventListener('click', function (event) {
      var button = event.target.closest(
        'button[type="submit"], input[type="submit"], .shopify-payment-button button, [name="add"]'
      );
      if (!button) return;

      /* Give the theme's own option handler a moment, then force our real ID. */
      setTimeout(function () {
        var id = dvqvSyncVariantId(popup);
        if (!id) {
          console.warn('Quick View: unable to resolve selected Shopify variant.');
          return;
        }

        var form = button.closest('form') || popup.querySelector('form');
        if (form) {
          form.querySelectorAll('input[name="id"], select[name="id"]').forEach(function (input) {
            input.value = id;
          });
        }
      }, 0);
    }, true);

    popup.addEventListener('submit', function (event) {
      var form = event.target.closest('form');
      if (!form) return;

      var id = dvqvSyncVariantId(popup);
      if (!id) {
        event.preventDefault();
        alert('Please select an available color and size.');
        return;
      }

      form.querySelectorAll('input[name="id"], select[name="id"]').forEach(function (input) {
        input.value = id;
      });
    }, true);
      /*
     * Close Quick View after the theme successfully
     * adds the product to cart.
     *
     * This does NOT change the existing Add to Cart
     * or variant functionality.
     */
    var closeAfterCartAdd = false;

    popup.addEventListener('submit', function () {
      closeAfterCartAdd = true;

      setTimeout(function () {
        if (!closeAfterCartAdd) return;

        /*
         * Only close if the Quick View is still open.
         */
        if (
          popup.classList.contains('active')
        ) {
          closePopup();
        }

        closeAfterCartAdd = false;
      }, 1200);
    }, false);
  
  }


  function initializeVariantGallery(
    popup
  ) {

    if (!popup || popup._dvqvVariantInitialized) return;
    popup._dvqvVariantInitialized = true;

    function updateVariant() {
      /* Read the currently checked Color control first. This prevents
         the previous color (for example Skin) from surviving a switch. */
      var colorInput =
        popup.querySelector('input[type="radio"][name*="Color" i]:checked') ||
        popup.querySelector('input[type="radio"][data-option-name*="Color" i]:checked');

      if (colorInput) {
        var directColor = colorInput.value || colorInput.getAttribute('title') || colorInput.getAttribute('data-value');
        if (directColor) dvqvSetColorLabel(popup, directColor);
      }

      dvqvSyncVariantId(popup);


/* Re-initialize native quantity controls
   after variant/form updates */

setTimeout(
  function () {

    if (
      typeof amountClick ===
      'function'
    ) {

      var amounts =
        popup.querySelectorAll(
          '.input-amount:not(.input-amount-listening)'
        );

      if (amounts.length) {

        amountClick(
          Array.from(amounts)
        );

      }

    }

  },
  100
);


var variant =
  popup._dvqvSelectedVariant;
      if (variant) {
        var data = popup._dvqvProductData;
        if (data && Array.isArray(data.options)) {
          var colorIndex = data.options.findIndex(function (name) {
            return /color|colour/i.test(String(name));
          });
          if (colorIndex >= 0 && variant.options && variant.options[colorIndex]) {
            dvqvSetColorLabel(popup, variant.options[colorIndex]);
          }
        }
      }
      dvqvSyncGallery(popup);
    }

    popup.addEventListener('change', function (event) {
      var target = event.target;
      if (!target) return;

      var isOption =
        target.matches('input[type="radio"]') ||
        target.matches('select:not([name="id"])');

      if (!isOption) return;

      /*
       * Theme option scripts can run after our listener.
       * Re-sync several times so the final Shopify variant ID wins.
       */
      [0, 30, 80, 160, 300].forEach(function (delay) {
        setTimeout(updateVariant, delay);
      });
    }, true);

    popup.addEventListener('click', function (event) {
      var label = event.target.closest('label');
      if (!label) return;

      setTimeout(updateVariant, 20);
      setTimeout(updateVariant, 100);
      setTimeout(updateVariant, 250);
    }, true);

    dvqvProtectCartSubmit(popup);

    /* Initial state. */
    [0, 50, 150, 300, 500, 800].forEach(function (delay) {
      setTimeout(updateVariant, delay);
    });

    if (popup._dvqvVariantDataPromise) {
      popup._dvqvVariantDataPromise.then(function () {
        [0, 30, 120].forEach(function (delay) {
          setTimeout(updateVariant, delay);
        });
      });
    }
  }


  /*
   * =========================================================
   * PRODUCT CONTROLS
   * =========================================================
   */

 function initializeProductControls() {

  setTimeout(
    function () {

      try {

        if (
          typeof productVariantsEvt !==
          'undefined'
        ) {

          window.dispatchEvent(
            productVariantsEvt
          );

        }


        if (
          typeof productOptionsEvt !==
          'undefined'
        ) {

          window.dispatchEvent(
            productOptionsEvt
          );

        }


        if (
          typeof semanticSelectEvt !==
          'undefined'
        ) {

          window.dispatchEvent(
            semanticSelectEvt
          );

        }


        if (
          typeof semanticInputEvt !==
          'undefined'
        ) {

          window.dispatchEvent(
            semanticInputEvt
          );

        }


        if (
          typeof ajaxCart !==
          'undefined' &&
          ajaxCart.init
        ) {

          ajaxCart.init();

        }


        /* =================================================
           QUICK VIEW QUANTITY
           ================================================= */

        if (
          typeof amountClick ===
          'function'
        ) {

          var quickViewAmounts =
            document.querySelectorAll(
              '#dermawear-quick-view .input-amount:not(.input-amount-listening)'
            );

          if (
            quickViewAmounts.length
          ) {

            amountClick(
              Array.from(
                quickViewAmounts
              )
            );

          }

        }

      } catch (error) {

        console.log(
          'Quick View controls:',
          error
        );

      }

    },
    50
  );

}


  /*
   * =========================================================
   * OPEN PRODUCT
   * =========================================================
   */

  function openProduct(
    button
  ) {

    var productUrl =
      getProductUrl(button);


    if (!productUrl) {
      return;
    }


    /*
     * Open immediately.
     */

    openPopup();

    showLoader();


    var popup =
      document.getElementById(
        POPUP_ID
      );

    /*
     * Load Shopify's product JSON in parallel with the HTML.
     * This gives us the authoritative variant IDs/options.
     */
    dvqvLoadVariantData(
      productUrl,
      popup
    );


    var content =
      popup.querySelector(
        '.dvqv-content'
      );


    content.innerHTML = '';


    /*
     * Load cached/product HTML.
     */

    fetchProduct(
      productUrl
    )

      .then(
        function (productHTML) {

          var parser =
            new DOMParser();


          var temporaryPage =
            parser.parseFromString(
              productHTML,
              'text/html'
            );


          var product =
            temporaryPage.querySelector(
              'div[id$="main-product"]'
            );


          /*
           * Fallback.
           */

          if (!product) {

            product =
              temporaryPage.body
                .firstElementChild;

          }


          if (!product) {

            throw new Error(
              'Product HTML unavailable'
            );

          }


          /*
           * Prepare product.
           */

          product =
            prepareProduct(
              product,
              productUrl
            );


          /*
           * Insert into popup.
           */

          content.appendChild(
            product
          );


          /*
           * =================================================
           * IMPORTANT ORDER
           * =================================================
           *
           * 1. Product inserted
           * 2. Gallery initialized
           * 3. First image displayed
           * 4. Loader removed
           * 5. Variant controls initialized
           */

          initializeGallery(
            popup
          );

          /*
           * Quick View-only cleanup.
           */
          dvqvRemoveQuickViewSections(
            popup
          );

          dvqvAddFullDetailsButton(
            popup,
            productUrl
          );

          initializeVariantGallery(
            popup
          );

          /*
           * Final initial sync after all theme controls exist.
           */
          dvqvSyncVariantId(
            popup
          );

          var initialColor = dvqvGetColorValue(popup);
          if (initialColor) dvqvSetColorLabel(popup, initialColor);

          dvqvSyncGallery(
            popup
          );

          hideLoader();


          initializeProductControls();

          /* Theme scripts can add product info after first paint. Keep only
             Quick View-safe content without changing the PDP itself. */
          [150, 400, 900].forEach(function (delay) {
            setTimeout(function () {
              dvqvRemoveQuickViewSections(popup);
              dvqvAddFullDetailsButton(popup, productUrl);
              dvqvSyncVariantId(popup);
              dvqvSyncGallery(popup);
            }, delay);
          });


        }
      )

      .catch(
        function (error) {

          console.error(
            'Quick View:',
            error
          );


          content.innerHTML = `
            <div class="dvqv-error">
              <p>Unable to load product.</p>

              <a href="${productUrl}">
                View Product
              </a>
            </div>
          `;


          hideLoader();

        }
      );

  }


  /*
   * =========================================================
   * QUICK VIEW CLICK
   * =========================================================
   */

  document.addEventListener(
    'click',
    function (event) {

      var button =
        event.target.closest(
          '[data-quickshop]'
        );


      if (!button) {
        return;
      }


      /*
       * Stop original drawer.
       */

      event.preventDefault();

      event.stopImmediatePropagation();


      openProduct(
        button
      );

    },
    true
  );


  /*
   * =========================================================
   * PRELOAD ON MOUSE ENTER
   * =========================================================
   */

  document.addEventListener(
    'mouseenter',
    function (event) {

      var button =
        event.target.closest(
          '[data-quickshop]'
        );


      if (!button) {
        return;
      }


      preloadProduct(
        button
      );

    },
    true
  );


  /*
   * =========================================================
   * ESCAPE
   * =========================================================
   */

  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Escape'
      ) {

        closePopup();

      }

    }
  );


})();

